import React, { useEffect, useState, useMemo } from 'react';
import { Form, Input, Select, Row, Col, Card, Button, Switch, Radio, Modal, message } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import backIcon from '../../../Images/addstarsbackIcon.png';
import expandIcon from '../../../Images/expandAddStar.png';
import '../../../components/Dashboard/Clan/knowYourRole/Star/starsAdd.css';
import { useMutation, useQuery, useLazyQuery } from '@apollo/client';
import {
    Get_Expert_Video,
    Get_Not_Expert_Profile,
    Get_Task_By_Activity,
    Get_Subtask_By_Task,
    Get_Account_Experts,
    Get_Video_Activity_By_Role,
    Add_Video_Content,
    Get_Video_Task_By_Activity,
    Get_Video_Subtask_By_Task,
    Update_Video_Content_By_Id,
    Delete_All_Video_Content,
    GET_SUBTASK_KII_RELATION,
    GET_ACCOUNT_EXPERTS_FULLNAME_EMPID_LOCATION,
} from '../../../services/userAPI';
import SelectDropdown from 'react-select';
import PageBreadcrumb from '../../../reusableField/PageBreadcrumb';

const { TextArea } = Input;

const AdminAddContentLibrary = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const location = useLocation();
    const name = location.state?.name;
    const accountName = location.state?.accountName;
    const roleId = location.state?.roleId;

    const [discardModalVisible, setDiscardModalVisible] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [globalDeleteModalVisible, setGlobalDeleteModalVisible] = useState(false);
    const [deleteContentId, setDeleteContentId] = useState(null);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [deleteName, setDeleteName] = useState(null);
    const [isOriginalContent, setIsOriginalContent] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const isEditMode = location.state?.isEdit || false;
    const editData = location.state?.editData || null;

    const accountId =
        location.state?.accountId ||
        location.state?.editData?.accountId ||
        location.state?.editData?.stars?.[0]?.accountId;

    const { data: activitiesData, loading: activitiesLoading } = useQuery(Get_Video_Activity_By_Role, {
        variables: {
            jobroleId: roleId,
            fullHierarchy: true,
        },
        skip: !roleId,
    });

    const [addVideoContent, { loading: addVideoLoading }] = useMutation(Add_Video_Content, {
        onError: (error) => {
            console.error('Add_Video_Content error:', error);
            message.error(`Failed to add video content: ${error.message}`);
        },
    });

    const [deleteVideoContent, { loading: deleteVideoLoading }] = useMutation(Delete_All_Video_Content, {
        onCompleted: (data) => {
            if (data.deleteContent.success) {
                message.success('Video content deleted successfully');
            } else {
                message.error(data.deleteContent.message || 'Failed to delete video content');
            }
        },
        onError: (error) => {
            message.error('Error deleting video: ' + error.message);
        },
    });

    const [updateVideoContent, { loading: updateVideoLoading }] = useMutation(Update_Video_Content_By_Id, {
        onCompleted: (data) => {
            if (data.updateVideoContent.success) {
                message.success('Video content updated successfully');
                // navigate(-1);
            } else {
                message.error(data.updateVideoContent.message || 'Failed to update video content');
            }
        },
        onError: (error) => {
            message.error('Error updating video: ' + error.message);
        },
    });

    const { data: userData, loading: userLoading } = useQuery(Get_Not_Expert_Profile, {
        variables: { accountId },
        skip: !accountId,
        onCompleted: (data) => {
            if (data?.getNotExpert) {
                console.log('Stars data structure:', data.getNotExpert);
            }
        },
        onError: (err) => {
            console.error('User API Error:', err);
        },
    });

    const { data: languagesData, loading: languagesLoading } = useQuery(Get_Expert_Video, {
        onCompleted: (data) => {
            console.log('languagesData:', data);
        },
    });

    const [starNameToIdMap, setStarNameToIdMap] = useState({});
    const [tasks, setTasks] = useState([]);
    const [subTasks, setSubTasks] = useState([]);

    const [activityId, setActivityId] = useState(null);
    const [taskId, setTaskId] = useState(null);
    const [subTaskId, setSubTaskId] = useState(null);
    const [leadIndicators, setLeadIndicators] = useState([]);

    const [languageMap, setLanguageMap] = useState({
        nameToId: {},
        idToName: {},
    });

    const [stars, setStars] = useState([]);

    useEffect(() => {
        if (userData?.users?.length) {
            const newMap = {};
            userData.users.forEach((user) => {
                newMap[`${user.name} (${user.employeeId})`] = user.id;
            });
            setStarNameToIdMap((prev) => ({ ...prev, ...newMap }));
        }
    }, [userData]);

    useEffect(() => {
        if (languagesData?.mdLanguages?.length) {
            const nameToId = {};
            const idToName = {};

            languagesData.mdLanguages.forEach((lang) => {
                if (lang.name) {
                    nameToId[lang.name.toLowerCase()] = lang.id;
                    idToName[lang.id] = lang.name.toLowerCase();
                }
            });

            setLanguageMap({ nameToId, idToName });
        }
    }, [languagesData]);

    const [fetchTasks, { loading: tasksLoading, data: tasksData }] = useLazyQuery(Get_Video_Task_By_Activity, {
        onCompleted: (data) => {
            if (data?.listCriticalTasks) {
                const taskOptions = data.listCriticalTasks.map((task) => ({
                    value: task.id,
                    label: task.name,
                }));
                setTasks(taskOptions);

                if (isEditMode && editData?.otherLanguagesContent?.[0]?.taskName) {
                    const matchedTask = data.listCriticalTasks.find(
                        (task) => task.name && editData.otherLanguagesContent[0].taskName && task.name.toLowerCase() === editData.otherLanguagesContent[0].taskName.toLowerCase()
                    );
                    if (matchedTask) {
                        setTaskId(matchedTask.id);
                        form.setFieldsValue({ task: matchedTask.id });

                        fetchSubtasks({
                            variables: {
                                taskId: matchedTask.id,
                                fullHierarchy: true,
                                searchTerm: '',
                            },
                        });
                    } else {
                        console.warn('No matching task found for taskName:', editData.otherLanguagesContent[0].taskName);
                    }
                }
            } else {
                console.warn('No tasks returned from Get_Video_Task_By_Activity');
            }
        },
        onError: (error) => {
            console.error('Error fetching tasks:', error);
            setTasks([]);
            setSubTasks([]);
            message.error('Failed to fetch tasks');
        },
    });

    const [fetchSubtasks, { loading: subtasksLoading, data: subtasksData }] = useLazyQuery(Get_Video_Subtask_By_Task, {
        onCompleted: (data) => {
            if (data?.listCriticalSubtask) {
                const filteredSubtasks = data.listCriticalSubtask
                    .filter((subtask) => subtask.isCritical === true)
                    .map((subtask) => ({
                        value: subtask.id,
                        label: subtask.name,
                    }));

                setSubTasks(filteredSubtasks);

                if (isEditMode && editData?.otherLanguagesContent?.[0]?.subTaskName) {
                    const matchedSubTask = data.listCriticalSubtask.find(
                        (subtask) => subtask.name && editData.otherLanguagesContent[0].subTaskName && subtask.name.toLowerCase() === editData.otherLanguagesContent[0].subTaskName.toLowerCase()
                    );
                    if (matchedSubTask) {
                        setSubTaskId(matchedSubTask.id);
                        form.setFieldsValue({ subTask: matchedSubTask.id });
                    } else {
                        console.warn('No matching subtask found for subTaskName:', editData.otherLanguagesContent[0].subTaskName);
                        const currentSubTask = form.getFieldsValue().subTask;
                        if (currentSubTask) {
                            setSubTaskId(currentSubTask);
                        }
                    }
                }
            } else {
                console.warn('No subtasks returned from Get_Video_Subtask_By_Task');
                message.error('No critical subtasks available');
            }
        },
        onError: (error) => {
            console.error('Error fetching subtasks:', error);
            setSubTasks([]);
            message.error('Failed to fetch subtasks');
        },
    });

    const [fetchLeadIndicators, { loading: leadIndicatorsLoading }] = useLazyQuery(GET_SUBTASK_KII_RELATION, {
        onCompleted: (data) => {
            if (data?.getSubtaskKiiRelation) {
                setLeadIndicators(data.getSubtaskKiiRelation.map((item) => ({
                    value: item.kiiId,
                    label: item.kiiName,
                })));
            } else {
                setLeadIndicators([]);
            }
        },
        onError: () => {
            setLeadIndicators([]);
        },
    });

    const { data: expertsData, loading: expertsLoading } = useQuery(Get_Account_Experts, {
        variables: {
            accountId: accountId,
            pagingCriteria: {
                limit: 5,
                cursor: null,
                sortByField: 'created_at',
                sortOrder: 'desc',
            },
        },
        skip: !accountId,
        onCompleted: (data) => {
            console.log('Experts API Success:', data);
        },
        onError: (err) => {
            console.error('Experts API Error:', err);
        },
    });

    const [expertSearchTerm, setExpertSearchTerm] = useState("");

    const [fetchExperts, { data: expertsSearchData, loading: expertsSearchLoading }] = useLazyQuery(GET_ACCOUNT_EXPERTS_FULLNAME_EMPID_LOCATION, {
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (accountId) {
            fetchExperts({ variables: { accountId: parseInt(accountId), searchTerm: "", pagingCriteria: { limit: 50, cursor: null, sortByField: "created_at", sortOrder: "desc" } } });
        }
    }, [accountId]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (accountId) {
                fetchExperts({ variables: { accountId: parseInt(accountId), searchTerm: expertSearchTerm, pagingCriteria: { limit: 50, cursor: null, sortByField: "created_at", sortOrder: "desc" } } });
            }
        }, 300);
        return () => clearTimeout(timer);
    }, [expertSearchTerm]);

    const expertOptions = useMemo(() => {
        const experts = expertsSearchData?.getAccountExpertsFullnameEmpidLocation?.data || [];
        return experts.map(expert => {
            const fullName = [expert.name, expert.surname].filter(Boolean).join(' ');
            const loc = expert.location || '';
            const labelParts = [fullName, expert.employeeId, loc].filter(Boolean);
            return { value: expert.id, label: labelParts.join(' | ') };
        });
    }, [expertsSearchData]);

    useEffect(() => {
        if (expertsData?.getAccountExperts?.data?.length) {
            const newMap = {};
            expertsData.getAccountExperts.data.forEach((expert) => {
                newMap[`${expert.name} (${expert.employeeId || 'No ID'})`] = expert.id;
            });
            setStarNameToIdMap((prev) => ({ ...prev, ...newMap }));
        }
    }, [expertsData]);

    const handleActivityChange = (activityId) => {
        form.setFieldsValue({
            task: undefined,
            subTask: undefined,
        });

        if (activityId) {
            fetchTasks({
                variables: {
                    activityId: activityId,
                    roleId: roleId,
                    searchTerm: '',
                },
            });
        } else {
            setTasks([]);
            setSubTasks([]);
        }
    };

    const handleTaskChange = (taskId) => {
        form.setFieldsValue({
            subTask: undefined,
        });

        if (taskId) {
            fetchSubtasks({
                variables: {
                    taskId: taskId,
                    fullHierarchy: true,
                    searchTerm: '',
                },
            });
        } else {
            setSubTasks([]);
        }
    };

    const convertSecondsToMMSS = (totalSeconds) => {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const handleSubmit = async (values) => {
        setErrorMessage(null);
        try {
            await form.validateFields();

            const videoData = values.stars.map((item, index) => {
                if (!/^\d{1,2}:\d{2}$/.test(item.duration)) {
                    throw new Error(`Invalid duration format for video ${index + 1}: ${item.duration}`);
                }

                const [minutes, seconds] = item.duration.split(':').map(Number);
                const totalSeconds = minutes * 60 + seconds;

                let userId = values.star;
                if (!userId) {
                    throw new Error(`Missing userId for video ${index + 1}`);
                }

                let languageId = item.videoLanguage;
                if (!languageId || (typeof languageId === 'string' && !languageMap.nameToId[item.videoLanguage?.toLowerCase()])) {
                    throw new Error(`Invalid languageId for video ${index + 1}: ${item.videoLanguage}`);
                }
                languageId = typeof languageId === 'string' && item.videoLanguage ? languageMap.nameToId[item.videoLanguage.toLowerCase()] : languageId;

                const subtaskId = isEditMode ? (subTaskId || values.subTask) : values.subTask;
                if (!subtaskId) {
                    throw new Error(`Missing subtaskId for video ${index + 1}`);
                }

                const keyPointIds = item.keyPointIds || {};

                const video = {
                    accountId: accountId,
                    roleId: roleId,
                    subtaskId: subtaskId,
                    title: item.videoTitle,
                    languageId: languageId,
                    commitmentNeeded: values.commitmentNeeded || false,
                    description: item.videoDescription,
                    code: item.youtubeCode,
                    thumbnailUrl: item.videoThumbnailCode,
                    lengthInSeconds: totalSeconds,
                    category: values.format,
                    userId: userId,
                    contentTags: [values.format],
                    keyPoints: [
                        { id: isEditMode ? keyPointIds.takeaway1 || null : null, keyPoint: item.takeaway1 || '' },
                        { id: isEditMode ? keyPointIds.takeaway2 || null : null, keyPoint: item.takeaway2 || '' },
                        { id: isEditMode ? keyPointIds.takeaway3 || null : null, keyPoint: item.takeaway3 || '' },
                    ].filter(kp => kp.keyPoint),
                    quiz: {
                        question: item.quizQuestion || '',
                        answerList: [item.quizOptionA || '', item.quizOptionB || ''].filter(Boolean),
                        answerValue: item.correctAnswer === 'A' ? 1 : item.correctAnswer === 'B' ? 2 : null,
                    },
                    originalContent: item.original || false,
                    relatedKiiId: values.leadIndicators || [],
                    contentId: isEditMode ? (item.contentId || null) : null,
                };

                return video;
            });

            if (isEditMode) {
                let allUpdatesSuccessful = true;

                const { data } = await addVideoContent({
                    variables: { videosList: videoData },
                });

                if (data?.addVideoContent?.success) {
                    message.success('Video content added successfully');
                    form.resetFields();
                    form.setFieldsValue({
                        stars: [{ original: true }],
                    });
                } else {
                    message.error(data?.addVideoContent?.message || 'Failed to add video content');
                }
                if (allUpdatesSuccessful) {
                    navigate(-1); // Navigate only once after all updates
                }
            } else {
                const { data } = await addVideoContent({
                    variables: { videosList: videoData },
                });
                if (data?.addVideoContent?.success) {
                    message.success('Video content added successfully');
                    form.resetFields();
                    form.setFieldsValue({
                        stars: [{ original: true }],
                    });
                    navigate(-1);
                } else {
                    message.error(data?.addVideoContent?.message || 'Failed to add video content');
                }
            }
        } catch (error) {
            console.error('Submission error:', error);
            if (error.message.includes('Invalid duration format') ||
                error.message.includes('Content ID is missing') ||
                error.message.includes('Invalid languageId') ||
                error.message.includes('Missing subtaskId') ||
                error.message.includes('Missing userId')) {
                message.error(error.message);
            } else {
            }
        }
    };

    const handleDelete = async (contentId) => {
        if (!contentId) {
            return;
        }

        await deleteVideoContent({
            variables: { contentId: parseInt(contentId) },
        });
    };

    const handleOpenDeleteModal = (name, index, contentId) => {
        const starsValues = form.getFieldValue('stars') || [];
        const isOriginal = starsValues[index]?.original || false;
        setIsOriginalContent(isOriginal);
        setDeleteModalVisible(true);
        setDeleteContentId(contentId);
        setDeleteIndex(index);
        setDeleteName(name);
    };

    const handleConfirmDelete = async (remove) => {
        try {
            if (deleteContentId) {
                await handleDelete(deleteContentId);
            }
            remove(deleteName);
            setStars((prev) => prev.filter((s) => s.id !== stars[deleteIndex]?.id));
            setDeleteModalVisible(false);
            setDeleteContentId(null);
            setDeleteIndex(null);
            setDeleteName(null);
            setIsOriginalContent(false);
            if (isEditMode) {
                navigate(-1);
            }
        } catch (error) {
            console.error('Error deleting video:', error);
            message.error('Failed to delete video');
            setDeleteModalVisible(false);
            setIsOriginalContent(false);
        }
    };

    const handleRemoveVideo = async (name, index, contentId, remove) => {
        try {
            if (contentId) {
                await handleDelete(contentId);
            }
            remove(name);
            setStars((prev) => prev.filter((s) => s.id !== stars[index]?.id));
            message.success('Video removed successfully');
        } catch (error) {
            console.error('Error removing video:', error);
            message.error('Failed to remove video');
        }
    };

    const confirmDeleteAll = async () => {
        try {
            const values = form.getFieldsValue();
            const contentIds = (values.stars || [])
                .map((star) => star.contentId)
                .filter((id) => id);
            const hasOriginal = (values.stars || []).some((star) => star.original === true);
            setIsOriginalContent(hasOriginal);
            setGlobalDeleteModalVisible(true);
            if (!contentIds.length) {
                form.resetFields();
                form.setFieldsValue({
                    stars: [{ original: true }],
                });
                if (isEditMode) {
                    navigate(-1);
                }
                message.success('All videos deleted successfully');
                setGlobalDeleteModalVisible(false);
                setIsOriginalContent(false);
            }
        } catch (error) {
            console.error('Error preparing to delete all videos:', error);
            message.error('Failed to prepare deletion');
            setGlobalDeleteModalVisible(false);
            setIsOriginalContent(false);
        }
    };

    const handleConfirmGlobalDelete = async () => {
        try {
            const values = form.getFieldsValue();
            const contentIds = (values.stars || [])
                .map((star) => star.contentId)
                .filter((id) => id);
            for (const contentId of contentIds) {
                await handleDelete(contentId);
            }
            form.resetFields();
            form.setFieldsValue({
                stars: [{ original: true }],
            });
            if (isEditMode) {
                navigate(-1);
            }
            message.success('All videos deleted successfully');
            setGlobalDeleteModalVisible(false);
            setIsOriginalContent(false);
        } catch (error) {
            console.error('Error deleting all videos:', error);
            message.error('Failed to delete videos');
            setGlobalDeleteModalVisible(false);
            setIsOriginalContent(false);
        }
    };

    useEffect(() => {
        if (isEditMode && editData?.otherLanguagesContent?.length > 0) {
            const videos = editData.otherLanguagesContent;

            // Create starData array
            let starData = videos.map(video => {
                const starQuizData = editData.stars?.find(s => String(s.videoId) === String(video.videoId)) || {};
                const quizDetails = video.quizDetails || {};
                const quizAnswers = quizDetails.answer || [];
                const quizOptionA = starQuizData.quizOptionA || quizAnswers[0]?.optionsAnswer || '';
                const quizOptionB = starQuizData.quizOptionB || quizAnswers[1]?.optionsAnswer || '';
                const correctAnswer = starQuizData.correctAnswer || (
                    quizAnswers.find(ans => ans.isanswer)?.optionsAnswer === quizOptionA ? 'A' :
                        quizAnswers.find(ans => ans.isanswer)?.optionsAnswer === quizOptionB ? 'B' : ''
                );

                return {
                    youtubeCode: video.code || '',
                    videoTitle: video.title || '',
                    videoThumbnailCode: video.vimeoThumbnailUrl || '',
                    duration: convertSecondsToMMSS((video.videoLengthMins * 60) + video.videoLengthSecs) || '00:00',
                    videoLanguage: video.languageId || '',
                    original: video.originalContent || false,
                    videoDescription: video.description || '',
                    takeaway1: video.keyPoints?.[0]?.keyPoint || '',
                    takeaway2: video.keyPoints?.[1]?.keyPoint || '',
                    takeaway3: video.keyPoints?.[2]?.keyPoint || '',
                    keyPointIds: {
                        takeaway1: video.keyPoints?.[0]?.id || null,
                        takeaway2: video.keyPoints?.[1]?.id || null,
                        takeaway3: video.keyPoints?.[2]?.id || null
                    },
                    quizQuestion: quizDetails.question || '',
                    quizOptionA: quizOptionA,
                    quizOptionB: quizOptionB,
                    correctAnswer: correctAnswer,
                    contentId: parseInt(video.id) || 0,
                };
            });

            // Sort starData to prioritize the clicked videoId
            const clickedVideoId = String(editData.videoId);
            starData.sort((a, b) => {
                if (String(a.contentId) === clickedVideoId) return -1;
                if (String(b.contentId) === clickedVideoId) return 1;
                // Fallback to originalContent sorting
                if (a.original === true && b.original !== true) return -1;
                if (a.original !== true && b.original === true) return 1;
                return 0;
            });

            // Find the starQuizData for the first video in starData (after sorting)
            const firstStarQuizData = editData.stars?.find(s => String(s.videoId) === String(starData[0]?.contentId)) || {};

            // Set stars state based on the sorted starData
            setStars(starData.map((_, index) => ({
                id: index + 1,
                expanded: index === 0,
            })));

            const formData = {
                stars: starData,
                format: starData[0]?.format || videos[0]?.fourmatCategory || undefined,
                star: starData[0]?.userId || videos[0]?.createdBy?.id || undefined,
                commitmentNeeded: firstStarQuizData.commitmentNeeded || videos[0]?.commitmentNeeded || false, // Use firstStarQuizData
                activity: firstStarQuizData.activityId || videos[0]?.activityId || undefined, // Use firstStarQuizData
                task: firstStarQuizData.taskId || videos[0]?.taskId || undefined, // Use firstStarQuizData
                subTask: firstStarQuizData.subTaskId || videos[0]?.subtaskId || undefined, // Use firstStarQuizData
                leadIndicators: videos[0]?.relatedKiis?.map(kii => kii.id) || [],
            };

            if (videos[0]?.relatedKiis?.length) {
                setLeadIndicators(videos[0].relatedKiis.map(kii => ({
                    value: kii.id,
                    label: kii.name,
                })));
            }

            if (videos[0]?.activityId) {
                setActivityId(videos[0].activityId);
                fetchTasks({
                    variables: {
                        activityId: videos[0].activityId,
                        roleId: roleId,
                        searchTerm: '',
                    },
                });
            }

            form.setFieldsValue(formData);

            if (formData.subTask && !subTaskId) {
                setSubTaskId(formData.subTask);
                fetchLeadIndicators({ variables: { subtaskId: formData.subTask } });
            }
        } else {
            setStars([{ id: 1, expanded: true }]);
            form.setFieldsValue({
                stars: [{ original: true }],
            });
        }
    }, [isEditMode, editData, form, fetchTasks, roleId]);

    const [youtubeCodeValues, setYoutubeCodeValues] = useState({});

    const handleYoutubeCodeChange = (e, fieldIndex) => {
        const value = e.target.value;

        setYoutubeCodeValues((prev) => ({
            ...prev,
            [fieldIndex]: value,
        }));

        const currentValues = form.getFieldsValue();
        const currentThumbnail = currentValues.stars?.[fieldIndex]?.videoThumbnailCode || '';
        const isAutoGenerated = currentThumbnail && currentThumbnail.includes('https://img.youtube.com/vi/');

        if (value && (isAutoGenerated || !currentThumbnail)) {
            const thumbnailUrl = `https://img.youtube.com/vi/${value}/0.jpg`;
            const updatedStars = [...(currentValues.stars || [])];
            if (updatedStars[fieldIndex]) {
                updatedStars[fieldIndex].videoThumbnailCode = thumbnailUrl;
                form.setFieldsValue({
                    stars: updatedStars,
                });
            }
        }
    };

    const handleOriginalChange = (checked, index) => {
        const currentValues = form.getFieldsValue();
        const currentStars = currentValues.stars || [];

        // Count how many panels currently have original: true
        const originalCount = currentStars.reduce((count, star) => count + (star.original ? 1 : 0), 0);

        // Prevent turning off the last original
        if (!checked && originalCount === 1 && currentStars[index].original) {
            message.warning('At least one video must be marked as Original.');
            return;
        }

        const updatedStars = currentStars.map((star, i) => ({
            ...star,
            original: i === index ? checked : checked ? false : star.original,
        }));

        form.setFieldsValue({
            stars: updatedStars,
        });
    };

    const toggleExpand = (id) => {
        setStars((prevStars) =>
            prevStars.map((star) => ({
                ...star,
                expanded: star.id === id ? !star.expanded : star.expanded,
            }))
        );
    };

    const addAnotherStar = (add) => {
        form
            .validateFields(
                stars.map((_, index) => [
                    ['stars', index, 'youtubeCode'],
                    ['stars', index, 'videoTitle'],
                    ['stars', index, 'videoThumbnailCode'],
                    ['stars', index, 'videoLanguage'],
                    ['stars', index, 'duration'],
                    ['stars', index, 'videoDescription'],
                    ['stars', index, 'takeaway1'],
                    ['stars', index, 'takeaway2'],
                    ['stars', index, 'takeaway3'],
                    ['stars', index, 'quizQuestion'],
                    ['stars', index, 'quizOptionA'],
                    ['stars', index, 'quizOptionB'],
                    ['stars', index, 'correctAnswer'],
                ]).flat()
            )
            .then(() => {
                const newId = stars.length > 0 ? Math.max(...stars.map((s) => s.id)) + 1 : 1;
                setStars((prevStars) =>
                    prevStars
                        .map((star) => ({ ...star, expanded: false }))
                        .concat({ id: newId, expanded: true })
                );
                add({ original: false });
            })
            .catch((error) => {
                console.error('Validation failed:', error);
                message.error('Please fill all required fields in the current video details.');
            });
    };

    const handlePartialSubmit = async (fieldIndex) => {
        try {
            // Validate only the current star entry
            await form.validateFields([
                ['stars', fieldIndex, 'youtubeCode'],
                ['stars', fieldIndex, 'videoTitle'],
                ['stars', fieldIndex, 'videoThumbnailCode'],
                ['stars', fieldIndex, 'duration'],
                ['stars', fieldIndex, 'videoLanguage'],
                ['stars', fieldIndex, 'videoDescription'],
                ['stars', fieldIndex, 'takeaway1'],
                ['stars', fieldIndex, 'takeaway2'],
                ['stars', fieldIndex, 'takeaway3'],
                ['stars', fieldIndex, 'quizQuestion'],
                ['stars', fieldIndex, 'quizOptionA'],
                ['stars', fieldIndex, 'quizOptionB'],
                ['stars', fieldIndex, 'correctAnswer'],
            ]);

            // If validation passes, proceed with full submission
            handleSubmit();
        } catch (error) {
            console.error('Partial validation error:', error);
            message.error('Please fill all required fields for the current video before submitting.');
            // Optionally focus on the first invalid field
            const errors = error.errorFields;
            if (errors.length > 0) {
                const firstErrorField = errors[0].name[1]; // Index of the invalid star
                const firstErrorName = errors[0].name[2]; // Name of the invalid field
                const inputRef = document.querySelector(`input[name="stars[${firstErrorField}][${firstErrorName}]"]`);
                if (inputRef) inputRef.focus();
            }
        }
    };


    const dartsFormNeeded = location.state?.dartsFormNeeded;
    const pocName = location.state?.pocName;
    const pocEmail = location.state?.pocEmail;
    const pocNumber = location.state?.pocNumber;
    const numberLogin = location.state?.numberLogin;
    const emailLogin = location.state?.emailLogin;
    const mandatoryTimeDistribution = location.state?.mandatoryTimeDistribution;
    const targetEditDays = location.state?.targetEditDays;
    const inputEditDays = location.state?.inputEditDays;
    const dartsNeeded = location.state?.dartsNeeded;
    const clanNeeded = location.state?.clanNeeded;
    const syncNeeded = location.state?.syncNeeded;

    const [inputType, setInputType] = useState(null);

    const handleBackToViewRole = () => {
        navigate("/admin-view-role", {
            state: {
                roleId: roleId || location.state?.roleId,
                accountId: accountId || location.state?.accountId,
                accountName: accountName || location.state?.accountName,
                name: name || location.state?.name,
                dartsNeeded: inputType ? true : dartsNeeded || location.state?.dartsNeeded, // Update based on inputType
                clanNeeded: clanNeeded || location.state?.clanNeeded,
                syncNeeded: syncNeeded || location.state?.syncNeeded,
                dartsFormNeeded: inputType === "Forms" || dartsFormNeeded || location.state?.dartsFormNeeded,
                pocName: pocName || location.state?.pocName,
                pocEmail: pocEmail || location.state?.pocEmail,
                pocNumber: pocNumber || location.state?.pocNumber,
                numberLogin: numberLogin || location.state?.numberLogin,
                emailLogin: emailLogin || location.state?.emailLogin,
                mandatoryTimeDistribution: mandatoryTimeDistribution || location.state?.mandatoryTimeDistribution,
                targetEditDays: targetEditDays || location.state?.targetEditDays,
                inputEditDays: inputEditDays || location.state?.inputEditDays,
            },
        });
    };

    return (
        <div className='user-management-container'>
            <PageBreadcrumb homePath="/admin-home">
                <span onClick={() => navigate('/admin-home')} style={{ cursor: 'pointer' }}>{accountName}</span>
                <span>&gt;</span>
                <span onClick={handleBackToViewRole} style={{ cursor: 'pointer' }}>{name}</span>
                <span>&gt;</span>
                <span>Clan</span>
                <span>&gt;</span>
                <span onClick={() => window.history.back()} style={{ cursor: 'pointer' }}>Content Library</span>
                <span>&gt;</span>
                <span style={{ fontWeight: 'bold' }}>{isEditMode ? 'Edit Content' : 'Add Content'}</span>
            </PageBreadcrumb>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: '500',
                    marginBottom: '2%',
                    // cursor: 'pointer',
                }}
                onClick={() => navigate(-1)}
            >
                {/* <img src={backIcon} alt="Back" style={{ marginRight: 8, height: '12px', width: '9px' }} /> */}
                {isEditMode ? 'Edit Content' : 'Add New Content'}
            </div>

            {/* <Card bodyStyle={{ paddingTop: 30, minHeight: 400, overflow: 'auto' }}> */}
            {errorMessage && (
                <div style={{ marginBottom: 16 }}>
                    <div
                        style={{
                            backgroundColor: '#fff1f0',
                            border: '1px solid #ffa39e',
                            borderRadius: 4,
                            padding: '8px 16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <span style={{ color: '#ff4d4f', marginRight: 8 }}>Error</span>
                        <span style={{ color: '#000' }}>{errorMessage}</span>
                        <Button
                            type="text"
                            onClick={() => setErrorMessage(null)}
                            style={{ marginLeft: 'auto', color: '#ff4d4f' }}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            )}

            <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
                <Card
                    title={<span style={{ fontWeight: '600' }}>Primary Detail</span>}
                    bordered={true}
                    style={{ borderRadius: 8, backgroundColor: 'white', marginBottom: 24 }}
                    headStyle={{ borderBottom: 'none', padding: '16px 24px', fontSize: 16 }}
                    bodyStyle={{ paddingTop: 0 }}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="activity"
                                label={<span>Activity<span style={{ color: '#AD0101' }}>*</span></span>}
                                rules={[{ required: true, message: 'Please select an activity' }]}
                            >
                                <Select
                                    showSearch
                                    className="custom-select"
                                    placeholder="Select an activity"
                                    loading={activitiesLoading}
                                    disabled={isEditMode}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={
                                        isEditMode && editData?.otherLanguagesContent?.[0]?.activityName
                                            ? [{ value: activityId, label: editData.otherLanguagesContent[0].activityName }]
                                            : activitiesData?.listCriticalActivities?.map((activity) => ({
                                                value: activity.id,
                                                label: activity.name,
                                            }))
                                    }
                                    onChange={handleActivityChange}

                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="task"
                                label={<span>Task<span style={{ color: '#AD0101' }}>*</span></span>}
                                rules={[{ required: true, message: 'Please select a task' }]}
                            >
                                <Select
                                    showSearch
                                    className="custom-select"
                                    placeholder="Select a task"
                                    loading={tasksLoading}
                                    disabled={isEditMode || tasks.length === 0}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={
                                        isEditMode && editData?.otherLanguagesContent?.[0]?.taskName
                                            ? [{ value: taskId, label: editData.otherLanguagesContent[0].taskName }]
                                            : tasks
                                    }
                                    onChange={handleTaskChange}

                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="subTask"
                                label={<span>Sub-Task<span style={{ color: '#AD0101' }}>*</span></span>}
                                rules={[{ required: true, message: 'Please select a sub-task' }]}
                            >
                                <Select
                                    showSearch
                                    className="custom-select"
                                    placeholder="Select a sub-task"
                                    loading={subtasksLoading}
                                    disabled={isEditMode || subTasks.length === 0}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={
                                        isEditMode && editData?.otherLanguagesContent?.[0]?.subTaskName
                                            ? [{ value: subTaskId, label: editData.otherLanguagesContent[0].subTaskName }]
                                            : subTasks
                                    }
                                    onChange={(value) => {
                                        setSubTaskId(value);
                                        form.setFieldsValue({ leadIndicators: [] });
                                        if (value) {
                                            fetchLeadIndicators({ variables: { subtaskId: value } });
                                        } else {
                                            setLeadIndicators([]);
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                name="leadIndicators"
                                label={<span>Lead Indicator</span>}
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    className="custom-select"
                                    placeholder="Select Lead Indicators"
                                    loading={leadIndicatorsLoading}
                                    disabled={isEditMode || !subTaskId}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={leadIndicators}
                                />
                            </Form.Item>
                        </Col>


                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="format"
                                label={<span>Category<span style={{ color: '#AD0101' }}>*</span></span>}
                                rules={[{ required: true, message: 'Please select a category' }]}
                            >
                                <Select
                                    showSearch
                                    className="custom-select"
                                    placeholder="Select a category"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={[
                                        { value: 'WHY', label: 'WHY' },
                                        { value: 'WHAT IF', label: 'WHAT IF' },
                                        { value: 'HOW', label: 'HOW' },
                                        { value: 'WHAT', label: 'WHAT' },
                                    ]}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                name="star"
                                label={<span>Select star<span style={{ color: '#AD0101' }}>*</span></span>}
                                rules={[{ required: true, message: 'Please select a star' }]}
                                getValueFromEvent={(selected) => selected ? selected.value : undefined}
                                getValueProps={(value) => ({
                                    value: expertOptions.find(opt => opt.value === value) || null
                                })}
                            >
                                <SelectDropdown
                                    options={expertOptions}
                                    onInputChange={(value) => setExpertSearchTerm(value)}
                                    onFocus={() => fetchExperts({ variables: { accountId: parseInt(accountId), searchTerm: "", pagingCriteria: { limit: 50, cursor: null, sortByField: "created_at", sortOrder: "desc" } } })}
                                    placeholder="Select star"
                                    isClearable
                                    isSearchable
                                    isDisabled={isEditMode}
                                    isLoading={expertsSearchLoading}
                                    filterOption={() => true}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        control: (base) => ({ ...base, minHeight: '32px' }),
                                        valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                        input: (base) => ({ ...base, margin: '0', padding: '0' }),
                                        indicatorsContainer: (base) => ({ ...base, height: '32px' }),
                                        menu: (base) => ({ ...base, minWidth: '350px', zIndex: 9999 }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (base) => ({ ...base, fontWeight: 'normal', fontSize: '13px' }),
                                        singleValue: (base) => ({ ...base, fontWeight: 'normal', fontSize: '13px' }),
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>

                        <Col span={12}>
                            <div
                                className={`switch-container ${isEditMode ? 'disabled' : ''}`}
                                style={{
                                    border: '1px solid #d9d9d9',
                                    borderRadius: 8,
                                    padding: '24px',
                                    height: '74%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <span style={{ fontWeight: 500 }}>Commitment needed?</span>
                                <Form.Item name="commitmentNeeded" valuePropName="checked" noStyle>
                                    <Switch disabled={isEditMode}
                                        className="ant-switch" />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                </Card>

                <Card>
                    <Form.List name="stars">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, ...restField }, index) => {
                                    const star = stars[index] || { id: index + 1, expanded: false };
                                    const contentId = form.getFieldValue(['stars', index, 'contentId']);
                                    return (
                                        <div key={key} style={{ marginBottom: 24, position: 'relative' }}>
                                            {!star.expanded && (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        padding: '12px 16px',
                                                        border: '1px solid #d9d9d9',
                                                        borderRadius: 8,
                                                        backgroundColor: '#fafafa',
                                                        marginBottom: 8,
                                                    }}
                                                >
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <h2 className="star-panel-title">
                                                            {form.getFieldValue(['stars', index, 'videoTitle']) || 'Untitled Video'}
                                                        </h2>
                                                        {form.getFieldValue(['stars', index, 'original']) === true ? (
                                                            <div className="original-label">
                                                                Original
                                                            </div>
                                                        ) : (
                                                            <div className="original-placeholder"></div>
                                                        )}
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        {!isEditMode && fields.length > 1 && (
                                                            <button
                                                                className="starAddRemove"
                                                                type="button"
                                                                onClick={() => handleRemoveVideo(name, index, contentId, remove)}
                                                                style={{ color: '#AD0101', cursor: 'pointer' }}
                                                            >
                                                                Remove
                                                            </button>
                                                        )}
                                                        {isEditMode && contentId && (
                                                            <button
                                                                className="addStarDelete"
                                                                type="button"
                                                                onClick={() => handleOpenDeleteModal(name, index, contentId)}
                                                                style={{
                                                                    padding: '8px 16px',
                                                                    border: '1px solid #AD0101',
                                                                    borderRadius: 4,
                                                                    background: '#fff',
                                                                    color: '#AD0101',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                Delete
                                                            </button>
                                                        )}
                                                        <img
                                                            src={expandIcon}
                                                            alt={star.expanded ? 'Collapse panel' : 'Expand panel'}
                                                            onClick={() => toggleExpand(star.id)}
                                                            style={{
                                                                width: '42px',
                                                                height: '42px',
                                                                padding: '4px',
                                                                cursor: 'pointer',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {star.expanded && (
                                                <>
                                                    {!isEditMode && fields.length > 1 && (
                                                        <button
                                                            className="starAddRemove"
                                                            type="button"
                                                            onClick={() => handleRemoveVideo(name, index, contentId, remove)}
                                                            style={{ position: 'absolute', right: 90, top: 20, zIndex: 1, color: '#AD0101', cursor: 'pointer' }}
                                                        >
                                                            Remove
                                                        </button>
                                                    )}
                                                    {isEditMode && contentId && (
                                                        <button
                                                            className="addStarDelete"
                                                            type="button"
                                                            onClick={() => handleOpenDeleteModal(name, index, contentId)}
                                                            style={{
                                                                position: 'absolute',
                                                                right: 90,
                                                                top: 20,
                                                                zIndex: 1,
                                                                padding: '8px 16px',
                                                                border: '1px solid #AD0101',
                                                                borderRadius: 4,
                                                                background: '#fff',
                                                                color: '#AD0101',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            Delete
                                                        </button>
                                                    )}
                                                    <Card
                                                        title={
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginRight: 'auto' }}>
                                                                    <span>Video Details</span>
                                                                    {form.getFieldValue(['stars', name, 'original']) === true ? (
                                                                        <div className="original-label">
                                                                            Original
                                                                        </div>
                                                                    ) : (
                                                                        <div className="original-placeholder"></div>
                                                                    )}
                                                                </div>
                                                                <img
                                                                    src={expandIcon}
                                                                    alt="Collapse panel"
                                                                    onClick={() => toggleExpand(star.id)}
                                                                    style={{
                                                                        width: '42px',
                                                                        height: '42px',
                                                                        padding: '4px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                />
                                                            </div>
                                                        }
                                                        bordered={true}
                                                        style={{ border: 'none', borderRadius: 8 }}
                                                        headStyle={{ borderBottom: 'none', padding: '0px 0px', fontSize: 16 }}
                                                        bodyStyle={{ padding: 0 }}
                                                    >
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Youtube Code<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'youtubeCode']}
                                                                    rules={[
                                                                        { required: true, message: 'Please enter YouTube code' },
                                                                        { min: 11, max: 11, message: 'YouTube code must be exactly 11 characters' }
                                                                    ]}
                                                                >
                                                                    <Input
                                                                        placeholder="Enter Video Code…"
                                                                        maxLength={11}
                                                                        onChange={(e) => handleYoutubeCodeChange(e, name)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Video Title<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'videoTitle']}
                                                                    rules={[{ required: true, message: 'Please enter video title' }]}
                                                                >
                                                                    <Input placeholder="Enter Video Title…"
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Thumbnail Code<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'videoThumbnailCode']}
                                                                // rules={[{ required: true, message: 'Please enter thumbnail code' }]}
                                                                >
                                                                    <Input placeholder="Enter Thumbnail Code…" disabled={true}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Video Duration<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'duration']}
                                                                    rules={[
                                                                        { required: true, message: 'Please enter duration' },
                                                                        {
                                                                            pattern: /^([0-5][0-9]):([0-5][0-9])$/,
                                                                            message: 'Format must be MM:SS (00:00 - 59:59)',
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Input placeholder="MM:SS"
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Language<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'videoLanguage']}
                                                                    rules={[{ required: true, message: 'Please select a language' }]}
                                                                >
                                                                    <Select
                                                                        showSearch
                                                                        placeholder="Select Language"
                                                                        loading={languagesLoading}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                                        }
                                                                        options={languagesData?.mdLanguages?.map((lang) => ({
                                                                            value: lang.id,
                                                                            label: lang.name,
                                                                        }))}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <div
                                                                    className={`switch-container ${isEditMode ? 'disabled' : ''}`}
                                                                    style={{
                                                                        border: '1px solid #d9d9d9',
                                                                        borderRadius: 8,
                                                                        padding: '24px',
                                                                        height: '74%',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'space-between',
                                                                    }}
                                                                >
                                                                    <span style={{ fontWeight: 500 }}>Original?</span>
                                                                    <Form.Item name={[name, 'original']} valuePropName="checked" noStyle>
                                                                        <Switch
                                                                            disabled={isEditMode}
                                                                            className="ant-switch"
                                                                            onChange={(checked) => handleOriginalChange(checked, index)}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col span={24}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Description<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'videoDescription']}
                                                                    rules={[{ required: true, message: 'Please enter video description' }]}
                                                                >
                                                                    <TextArea rows={4} placeholder="Write Video Description…"
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' && !e.shiftKey) {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    </Card>

                                                    <Card
                                                        title="Key Takeaways"
                                                        bordered={true}
                                                        style={{ border: '1px solid #000', borderRadius: 8, marginTop: '2%' }}
                                                        headStyle={{ borderBottom: 'none', padding: '16px 24px', fontSize: 16 }}
                                                        bodyStyle={{ paddingTop: 0 }}
                                                    >
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Takeaway 1<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'takeaway1']}
                                                                    rules={[{ required: true, message: 'Please enter takeaway 1.' }]}
                                                                >
                                                                    <TextArea rows={1} placeholder="Enter key take aways 1."
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Takeaway 2<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'takeaway2']}
                                                                    rules={[{ required: true, message: 'Please enter takeaway 2.' }]}
                                                                >
                                                                    <TextArea rows={1} placeholder="Enter key take aways 2."
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Takeaway 3</span>}
                                                                    name={[name, 'takeaway3']}
                                                                    rules={[{ message: 'Please enter takeaway 3.' }]}
                                                                >
                                                                    <TextArea rows={1} placeholder="Enter key take aways 3."
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    </Card>

                                                    <Card
                                                        // title="Quiz"
                                                        bordered={true}
                                                        style={{ border: '1px solid #000', borderRadius: 8, marginTop: '2%' }}
                                                        headStyle={{ borderBottom: 'none', padding: '16px 24px', fontSize: 16 }}
                                                        bodyStyle={{ paddingTop: 0 }}
                                                    >
                                                        <Row gutter={16}>
                                                            <Col span={24}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Quiz<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'quizQuestion']}
                                                                    rules={[{ required: true, message: 'Please enter a question.' }]}
                                                                >
                                                                    <Input placeholder="Write your question."
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Option A<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'quizOptionA']}
                                                                    rules={[{ required: true, message: 'Please enter option A.' }]}
                                                                >
                                                                    <Input placeholder="Enter option A."
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={<span>Option B<span style={{ color: '#AD0101' }}>*</span></span>}
                                                                    name={[name, 'quizOptionB']}
                                                                    rules={[{ required: true, message: 'Please enter option B.' }]}
                                                                >
                                                                    <Input placeholder="Enter option B."
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24}>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        marginTop: 8,
                                                                        marginBottom: 16,
                                                                    }}
                                                                >
                                                                    <span style={{ marginRight: 16, fontWeight: 500 }}>Correct Answer :</span>
                                                                    <Form.Item
                                                                        name={[name, 'correctAnswer']}
                                                                        style={{ marginBottom: 0 }}
                                                                        rules={[{ required: true, message: 'Select enter option A or option B.' }]}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                handlePartialSubmit(name);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <Radio.Group>
                                                                            <Radio value="A">Option A</Radio>
                                                                            <Radio value="B">Option B</Radio>
                                                                        </Radio.Group>
                                                                    </Form.Item>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </>
                                            )}
                                        </div>
                                    );
                                })}

                                <Modal
                                    open={deleteModalVisible}
                                    footer={[
                                        <div
                                            key="footer-buttons"
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                gap: '10px',
                                                width: '100%',
                                            }}
                                        >
                                            <button
                                                className="starsAddModal"
                                                onClick={() => handleConfirmDelete(fields[deleteIndex]?.field?.remove || (() => { }))}
                                                disabled={deleteVideoLoading}
                                                style={{ opacity: deleteVideoLoading ? 0.7 : 1, cursor: deleteVideoLoading ? 'not-allowed' : 'pointer' }}
                                            >
                                                {deleteVideoLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : 'Yes'}
                                            </button>
                                            <button
                                                className="starsAddModalCancel"
                                                onClick={() => {
                                                    setDeleteModalVisible(false);
                                                    setDeleteContentId(null);
                                                    setDeleteIndex(null);
                                                    setDeleteName(null);
                                                    setIsOriginalContent(false);
                                                }}
                                            >
                                                No
                                            </button>
                                        </div>,
                                    ]}
                                    centered
                                    onCancel={() => {
                                        setDeleteModalVisible(false);
                                        setDeleteContentId(null);
                                        setDeleteIndex(null);
                                        setDeleteName(null);
                                        setIsOriginalContent(false);
                                    }}
                                >
                                    <p style={{ fontFamily: 'Inter', fontWeight: '600', fontSize: '15px' }}>
                                        {isOriginalContent
                                            ? 'Do you want to remove the Original content?'
                                            : 'Do you want to remove this content?'}
                                    </p>
                                    <p style={{ fontFamily: 'Inter', fontSize: '14px' }}>
                                        {isOriginalContent
                                            ? 'Deletion of the content will remove it and its relating translated content from library! Are you Sure?'
                                            : 'Make sure that you want to remove this content from the library.'}
                                    </p>
                                </Modal>

                                <Modal
                                    open={globalDeleteModalVisible}
                                    footer={[
                                        <div
                                            key="footer-buttons"
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                gap: '10px',
                                                width: '100%',
                                            }}
                                        >
                                            <button
                                                className="starsAddModal"
                                                onClick={handleConfirmGlobalDelete}
                                                disabled={deleteVideoLoading}
                                                style={{ opacity: deleteVideoLoading ? 0.7 : 1, cursor: deleteVideoLoading ? 'not-allowed' : 'pointer' }}
                                            >
                                                {deleteVideoLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : 'Yes'}
                                            </button>
                                            <button
                                                className="starsAddModalCancel"
                                                onClick={() => {
                                                    setGlobalDeleteModalVisible(false);
                                                    setIsOriginalContent(false);
                                                }}
                                            >
                                                No
                                            </button>
                                        </div>,
                                    ]}
                                    centered
                                    onCancel={() => {
                                        setGlobalDeleteModalVisible(false);
                                        setIsOriginalContent(false);
                                    }}
                                >
                                    <p style={{ fontFamily: 'Inter', fontWeight: '600', fontSize: '15px' }}>
                                        Do you want to remove the Original content?
                                    </p>
                                    <p style={{ fontFamily: 'Inter', fontSize: '14px' }}>
                                        Deletion of the content will remove it and its relating translated content from library! Are you Sure?

                                    </p>
                                </Modal>

                                <Modal
                                    open={discardModalVisible}
                                    footer={[
                                        <div
                                            key="footer-buttons"
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                gap: '10px',
                                                width: '100%',
                                            }}
                                        >
                                            <button
                                                className="starsAddModal"
                                                onClick={() => {
                                                    form.resetFields();
                                                    setDiscardModalVisible(false);
                                                    navigate(-1);
                                                }}
                                                disabled={deleteVideoLoading}
                                                style={{ opacity: deleteVideoLoading ? 0.7 : 1, cursor: deleteVideoLoading ? 'not-allowed' : 'pointer' }}
                                            >
                                                {deleteVideoLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : 'Yes'}
                                            </button>
                                            <button
                                                className="starsAddModalCancel"
                                                onClick={() => setDiscardModalVisible(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>,
                                    ]}
                                    centered
                                    onCancel={() => setDiscardModalVisible(false)}
                                >
                                    <p style={{ fontFamily: 'Inter', fontWeight: '600', fontSize: '15px' }}>
                                        Do you want to discard changes?
                                    </p>
                                </Modal>

                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: 24,
                                        gap: 12,
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <button
                                            className="addAnotherStar"
                                            type="button"
                                            onClick={() => addAnotherStar(add)}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                                padding: '8px 16px',
                                                border: '1px solid #d9d9d9',
                                                borderRadius: 4,
                                                background: '#fff',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Add Video in Another Language
                                        </button>

                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        {(isEditMode || (form.getFieldsValue().stars?.length && form.getFieldsValue().stars.some(star => star.contentId))) && (
                                            <button
                                                className="addStarDelete"
                                                type="button"
                                                onClick={confirmDeleteAll}
                                                style={{
                                                    padding: '8px 16px',
                                                    border: '1px solid #AD0101',
                                                    borderRadius: 4,
                                                    background: '#fff',
                                                    color: '#AD0101',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                Delete
                                            </button>
                                        )}

                                        <button
                                            className="addStarDiscard"
                                            type="button"
                                            onClick={() => setDiscardModalVisible(true)}
                                            style={{
                                                padding: '8px 16px',
                                                border: '1px solid #d9d9d9',
                                                borderRadius: 4,
                                                background: '#fff',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {isEditMode ? 'Cancel' : 'Discard'}
                                        </button>
                                        <button
                                            className="addStarSave"
                                            type="submit"
                                            disabled={addVideoLoading || updateVideoLoading}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '8px 16px',
                                                border: 'none',
                                                borderRadius: 4,
                                                background: '#AD0101',
                                                color: '#fff',
                                                cursor: (addVideoLoading || updateVideoLoading) ? 'not-allowed' : 'pointer',
                                                opacity: (addVideoLoading || updateVideoLoading) ? 0.7 : 1,
                                            }}
                                        >
                                            {(addVideoLoading || updateVideoLoading) ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : (isEditMode ? 'Apply' : 'Save and Create')}
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </Form.List>
                </Card>
            </Form>
        </div>
    );
};

export default AdminAddContentLibrary;